<template>
  <div class="login-box3-wrapper" ref="loginWrapper">
    <div
      class="wechat-login-icon"
      @click="wxLogin"
      v-if="pageConfig.wxCode && type !== 'weChatLogin'"
    >
      <el-tooltip
        class="item"
        effect="dark"
        :content="$t('使用微信扫码登录')"
        placement="bottom"
      >
        <img src="../img/code.png" alt="" />
      </el-tooltip>
    </div>
    <el-form
      ref="loginForm"
      :model="loginForm"
      :rules="loginRules"
      v-if="type === 'loginForm'"
    >
      <div class="title">
        {{ pageConfig.loginBoxText || $t("用户登录") }}
        <el-button
          v-show="pageConfig.showRegistAgreement"
          @click="changeType('registerForm')"
          style="position: absolute; right: 30px; margin-left: 20px"
          type="text"
          >{{ $t("注册新用户") }}</el-button
        >
      </div>
      <el-form-item prop="username">
        <el-input
          style="width: 400px"
          type="text"
          :placeholder="$t('请输入用户名')"
          prefix-icon="el-icon-user-solid"
          v-model="loginForm.username"
        >
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          style="width: 400px"
          type="password"
          :placeholder="$t('请输入密码')"
          prefix-icon="el-icon-s-goods"
          @keyup.enter.native="handleLogin"
          v-model="loginForm.password"
        >
          <el-button
            @click="changeType('passwordForm')"
            style="margin-right: 24px; margin-top: 4px"
            slot="suffix"
            type="text"
            >{{ $t("忘记密码") }}</el-button
          >
        </el-input>
      </el-form-item>
      <!--新增验证码登陆-->
      <el-form-item prop="code" v-if="pageConfig.showCode"
                    :rules="NODE_ENV === 'production'?[
            { required: true, message: $t('请输入验证码'), trigger: 'blur' }
          ]:[]"
      >
        <el-input
            style="width:250px;"
            type="text"
            :placeholder="$t('输入验证码')"
            @keyup.enter.native="handleLogin"
            v-model="loginForm.code">
          <i slot="prefix" style="font-size:22px;margin-left:2px;" class="iconfont icon-renzhengdunpaianquanbaozhangzhibao" />
        </el-input>
        <el-button v-if="time === 0"  @click="getVerificationCode(loginForm.username)" style="margin-left:50px;margin-top:4px;" type="text">{{ $t('获取验证码') }}</el-button>
        <span style="display:inline-block;color: #848383;margin-left:10px;"  v-else class="show-pwd">
              {{time}}{{$t('S后重新获取')}}
          </span>
      </el-form-item>
<!--      <el-form-item-->
<!--        prop="code"-->
<!--        v-if="pageConfig.showCode"-->
<!--        :rules="-->
<!--          NODE_ENV === 'production'-->
<!--            ? [{ required: true, message: $t('请输入验证码'), trigger: 'blur' }]-->
<!--            : []-->
<!--        "-->
<!--      >-->
<!--        <el-input-->
<!--          style="width: 150px"-->
<!--          type="text"-->
<!--          :placeholder="$t('输入验证码')"-->
<!--          v-model="loginForm.code"-->
<!--        >-->
<!--          <i-->
<!--            slot="prefix"-->
<!--            style="font-size: 22px; margin-left: 2px"-->
<!--            class="iconfont icon-renzhengdunpaianquanbaozhangzhibao"-->
<!--          />-->
<!--        </el-input>-->
<!--        <div class="login-code">-->
<!--          <img-->
<!--            class="code_posi"-->
<!--            @click="getVerifyCodeUrl()"-->
<!--            :src="verifyCodeUrl"-->
<!--            alt=""-->
<!--          />-->
<!--        </div>-->
<!--        <el-button-->
<!--          @click="getVerifyCodeUrl()"-->
<!--          style="margin-left: 10px; margin-top: 4px"-->
<!--          type="text"-->
<!--          >{{ $t("换一组") }}</el-button-->
<!--        >-->
<!--      </el-form-item>-->
      <el-checkbox style="margin-left: 34px" v-model="rememberPassword"
        >{{ $t("记住密码") }}
      </el-checkbox>
      <fanjian
        style="position: static; float: right; margin-right: 20px"
        v-show="pageConfig.showFontSwitch"
        @changeFanjian="emitChangeFanjian"
      ></fanjian>
      <el-button
        type="primary"
        class="lodin-btn"
        @click.native.prevent="handleLogin"
      >
        {{ $t("登录") }}</el-button
      >
      <div class="web">
        <span class="red">*</span>
        {{ $t("推荐使用")
        }}<a class="link" href="https://www.google.cn/chrome/" target="_blank"
          >Google</a
        >
        {{ $t("或")
        }}<a class="link" href="https://www.firefox.com.cn/" target="_blank"
          >Firefox</a
        >
      </div>
    </el-form>
    <el-form
      ref="registerForm"
      :rules="registerRules"
      :model="registerForm"
      v-if="type === 'registerForm'"
    >
      <div class="title">{{ $t("用户注册") }}</div>
      <el-form-item prop="username">
        <el-input
          style="width: 400px"
          type="text"
          :placeholder="$t('请输入用户名')"
          prefix-icon="el-icon-user-solid"
          v-model="registerForm.username"
        >
        </el-input>
      </el-form-item>
      <el-form-item prop="telPhone">
        <el-input
          class="phone-input"
          style="width: 400px"
          type="text"
          :placeholder="$t('请输入手机号码')"
          v-model="registerForm.telPhone"
        >
          <span slot="prefix">
            <i
              style="font-size: 22px; margin-left: 2px"
              class="iconfont icon-shouji"
            />
            <phoneCodeSelect
              class="phone-code-input"
              v-model="registerForm.areaCode"
              style="margin-left: 2px"
            ></phoneCodeSelect>
          </span>
          <el-button
            v-if="time === 0"
            @click="getMessageCode()"
            style="margin-right: 24px; margin-top: 4px"
            slot="suffix"
            type="text"
          >
            {{ $t("获取验证码") }}</el-button
          >
          <span
            slot="suffix"
            style="
              display: inline-block;
              margin-right: 24px;
              margin-top: 6px;
              color: #848383;
            "
            v-else
            class="show-pwd"
          >
            {{ time }}{{ $t("后重新获取") }}
          </span>
        </el-input>
      </el-form-item>
      <el-form-item prop="telPhone">
        <el-input
          style="width: 400px"
          type="text"
          :placeholder="$t('请输入短信验证码')"
          v-model="registerForm.code"
        >
          <i
            slot="prefix"
            style="font-size: 22px; margin-left: 2px"
            class="iconfont icon-youxiang"
          />
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          style="width: 400px"
          type="password"
          :placeholder="$t('设置6至20位登录密码')"
          prefix-icon="el-icon-s-goods"
          v-model="registerForm.password"
        >
        </el-input>
      </el-form-item>
      <el-form-item prop="password2">
        <el-input
          style="width: 400px"
          type="password"
          :placeholder="$t('确认密码')"
          prefix-icon="el-icon-s-goods"
          v-model="registerForm.password2"
        >
        </el-input>
      </el-form-item>
      <el-checkbox style="margin-left: 34px" v-model="agree">{{
        $t("勾选同意")
      }}</el-checkbox>
      <a
        style="color: #2d73c7"
        @click="showModal = true"
        href="javascript:void(0);"
        >《{{ $t("用户服务协议") }}》</a
      >
      <el-button type="primary" class="lodin-btn" @click="handleRegister()">
        {{ $t("注册") }}</el-button
      >
      <div class="footer-btn-wrapper">
        <el-button
          @click="changeType('loginForm')"
          style="float: left; margin-left: 20px"
          type="text"
          >{{ $t("使用已有帐户登录") }}</el-button
        >
      </div>
    </el-form>
    <el-form
      ref="passwordForm"
      :rules="passwordRules"
      :model="passwordForm"
      v-if="type === 'passwordForm'"
    >
      <div class="title">{{ $t("找回密码") }}</div>
      <el-form-item prop="telPhone">
        <el-input
          class="phone-input"
          style="width: 400px"
          type="text"
          :placeholder="$t('请输入注册时的手机号码')"
          v-model="passwordForm.telPhone"
        >
          <span slot="prefix">
            <i
              style="font-size: 22px; margin-left: 2px"
              class="iconfont icon-shouji"
            />
            <phoneCodeSelect
              class="phone-code-input"
              v-model="passwordForm.areaCode"
              style="margin-left: 2px"
            ></phoneCodeSelect>
          </span>
          <el-button
            v-if="forgettime === 0"
            @click="getMessageCodeForget()"
            style="margin-right: 24px; margin-top: 4px"
            slot="suffix"
            type="text"
          >
            {{ $t("获取验证码") }}</el-button
          >
          <span
            slot="suffix"
            style="
              display: inline-block;
              margin-right: 24px;
              margin-top: 6px;
              color: #848383;
            "
            v-else
            class="show-pwd"
          >
            {{ forgettime }}{{ $t("后重新获取") }}
          </span>
        </el-input>
      </el-form-item>
      <el-form-item prop="telPhone">
        <el-input
          style="width: 400px"
          type="text"
          :placeholder="$t('请输入短信验证码')"
          v-model="passwordForm.code"
        >
          <i
            slot="prefix"
            style="font-size: 22px; margin-left: 2px"
            class="iconfont icon-youxiang"
          />
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          style="width: 400px"
          type="password"
          :placeholder="$t('设置6至20位登录密码')"
          prefix-icon="el-icon-s-goods"
          v-model="passwordForm.password"
        >
        </el-input>
      </el-form-item>
      <el-form-item prop="password2">
        <el-input
          style="width: 400px"
          type="password"
          :placeholder="$t('确认密码')"
          prefix-icon="el-icon-s-goods"
          v-model="passwordForm.password2"
        >
        </el-input>
      </el-form-item>
      <el-button type="primary" class="lodin-btn" @click="handlePassword()">
        {{ $t("重设密码") }}</el-button
      >
      <div class="footer-btn-wrapper">
        <el-button
          @click="changeType('loginForm')"
          style="float: left; margin-left: 20px"
          type="text"
          >{{ $t("返回登录") }}</el-button
        >
      </div>
    </el-form>
    <div class="wechat-login" v-if="type === 'weChatLogin'">
      <div class="title">
        <el-button
          type="text"
          style="position: absolute; top: 20px; right: 30px"
          @click="backLogin"
          >{{ $t("返回登录") }}</el-button
        >
        {{ $t("微信登录") }}
      </div>
      <img :src="WxQR" alt="" />
      <div style="text-align: center; margin-top: 10px; color: #9c9c9c">
        {{ $t("使用微信扫码登录") }}
      </div>
    </div>
    <user-agreement
      v-if="showModal"
      :showModal.sync="showModal"
      @check="checkAgreement"
    ></user-agreement>
    <div class="qr-code-box" v-if="pageConfig.showQrcode" ref="qrcodeBox">
      <i
        @click="pageConfig.showQrcode = false"
        class="el-icon-close"
        style="font-size: 20px; float: right; cursor: pointer"
      ></i>
      <h4>{{ pageConfig.loginPageTitle }}小程序</h4>
      <div class="qrcode-wrapper">
        <img src="/image/wechat.png" style="width: 120px; height: 120px" />
      </div>
      <div>
        <p>{{ $t("扫描访问小程序") }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import baseMixin from "../mixins/baseMixin";
import loginMixin from "../mixins/loginMixin";
import registerMixin from "../mixins/registerMixin";
import passwordMixin from "../mixins/passwordMixin";
export default {
  mixins: [baseMixin, loginMixin, registerMixin, passwordMixin],
  mounted() {
    this.$nextTick(() => {
      const body = document.querySelector("body");
      if (body.append) {
        body.append(this.$refs.qrcodeBox);
      } else {
        body.appendChild(this.$refs.qrcodeBox);
      }
    });
  },
  beforeDestroy() {
    const body = document.querySelector("body");
    if (this.$refs.qrcodeBox) {
      body.removeChild(this.$refs.qrcodeBox);
    }
  },
};
</script>

<style lang="scss">
.qr-code-box {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 11;
  width: 304px;
  padding: 10px 15px 22px;
  box-sizing: border-box;
  background-color: #fff;
  color: #4d555d;
  line-height: 16px;
  box-shadow: 0 8px 16px 0 rgba(7, 17, 27, 0.2);
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
  font-size: 12px;
  text-align: center;
}
.login-box3-wrapper {
  .el-form {
    background: #ffffff;
    border-radius: 3px;
    padding: 20px;
  }
  .el-input__inner {
    height: 48px !important;
    line-height: 48px !important;
    background: #fff;
    border-radius: 0;
    border: 1px solid #ddd !important;
    padding-left: 40px !important;
    color: #a5a5a5;
    font-size: 1rem;
    &::placeholder {
      color: #cccccc;
      font-size: 1rem;
    }
  }
  .phone-input > .el-input__inner {
    height: 48px !important;
    line-height: 48px !important;
    background: #fff;
    border-radius: 0;
    border: 1px solid #ddd !important;
    padding-left: 130px !important;
    color: #a5a5a5;
    font-size: 1rem;
    &::placeholder {
      color: #cccccc;
      font-size: 1rem;
    }
  }
  .phone-code-input .el-input__inner {
    border: none !important;
    background: transparent;
  }
  .el-form-item__error {
    font-size: 0.85rem;
    padding-left: 40px;
  }
  .el-input__prefix {
    left: 12px !important;
    right: auto !important;
    font-size: 22px;
    line-height: 44px;
    color: #cccccc;
  }
  .el-button--text {
    font-size: 1rem;
    color: #003e8f;
    &:hover {
      color: #003e8f;
    }
    &:focus {
      color: #003e8f;
    }
  }
  .el-checkbox__input .el-checkbox__inner {
    font-size: 1rem;
    background-color: #ffffff;
    border-color: #003e8f;
    width: 1rem;
    height: 1rem;
    &:after {
      height: 0.5rem;
      left: 0.28rem;
    }
  }
  .el-checkbox__input + .el-checkbox__label {
    font-size: 1rem;
    color: #a5a5a5;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #003e8f;
    border-color: #003e8f;
  }
  .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #003e8f;
  }
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #003e8f;
  }
}
</style>

<style lang="scss" scoped>
.login-box3-wrapper {
  font-size: 1rem;
  width: 480px;
  background: hsla(0, 0%, 100%, 0.3);
  border: 1px solid hsla(0, 0%, 100%, 0.8);
  padding: 20px;
  border-radius: 6px;
  position: relative;
  .wechat-login-icon {
    position: absolute;
    top: 25px;
    right: 25px;
    cursor: pointer;
  }
  .wechat-login {
    height: 409px;
    background: #fff;
    border-radius: 3px;
    padding: 20px;
    text-align: center;
  }
  .title {
    color: #808c94;
    font-size: 21px;
    padding: 10px 0 36px;
    font-weight: 100;
  }
  .login-code {
    text-align: center;
    display: inline-block;
    margin-left: 22px;
    vertical-align: middle;
    .code_posi {
      vertical-align: middle;
    }
  }
  .lodin-btn {
    width: 400px;
    height: 50px;
    background: #003e8f;
    border-radius: 0;
    font-size: 1.14rem;
    font-weight: 500;
    line-height: 28px;
    color: #fff;
    text-align: center;
    border: none;
    margin-top: 28px;
  }
  .footer-btn-wrapper {
    height: 30px;
  }
}
</style>